
import React, { useState, useContext, useEffect } from 'react';
import CheckIn from './CheckIn'; // Ensure the path is correct
import CheckOut from './CheckOut'; // Ensure the path is correct
import AdultsDropdown from './AdultsDropdown'; // Ensure the path is correct
import KidsDropdown from './KidsDropdown'; // Ensure the path is correct
import { RoomContext } from '../context/RoomContext'; // Import RoomContext correctly
import { SpinnerDotted } from 'spinners-react'; // Import spinner component
import {
  startOfToday,
  addDays,
  validateStayDates,
  parseLocalDate,
} from '../utils/dateUtils';

const BookForm = () => {
  const {
    setSelectedRoomDetails,
    adults,
    kids,
    searching,
    selectedRoomDetails,
    fetchAvailableRooms: fetchAvailableRoomsForStay,
  } = useContext(RoomContext);

  const [checkIn, setCheckIn] = useState(() => startOfToday());
  const [checkOut, setCheckOut] = useState(() => addDays(startOfToday(), 1));

  useEffect(() => {
    if (selectedRoomDetails.checkInDate) {
      const parsed = parseLocalDate(selectedRoomDetails.checkInDate);
      if (parsed) setCheckIn(parsed);
    }
    if (selectedRoomDetails.checkOutDate) {
      const parsed = parseLocalDate(selectedRoomDetails.checkOutDate);
      if (parsed) setCheckOut(parsed);
    }
  }, [selectedRoomDetails.checkInDate, selectedRoomDetails.checkOutDate]);

  const handleCheckInChange = (date) => {
    if (!date) return;
    setCheckIn(date);
    if (checkOut <= date) {
      setCheckOut(addDays(date, 1));
    }
  };

  const fetchAvailableRooms = async (e) => {
    e.preventDefault();
    const stay = validateStayDates(checkIn, checkOut);
    if (!stay.valid) {
      alert(stay.message);
      return;
    }

    setSelectedRoomDetails((prevDetails) => ({
      ...prevDetails,
      checkInDate: stay.checkInStr,
      checkOutDate: stay.checkOutStr,
      adults,
      kids,
      numberOfDays: stay.numberOfNights,
    }));

    const totalGuests = Number(adults) + Number(kids);

    try {
      const { rooms: available } = await fetchAvailableRoomsForStay({
        checkIn: stay.checkInStr,
        checkOut: stay.checkOutStr,
        maxPerson: totalGuests,
        showLoader: true,
      });

      if (available.length === 0) {
        alert('No rooms available for these dates and guest count. Try different dates.');
      }
    } catch (error) {
      console.error('Error fetching available rooms:', error);
      alert('Could not check availability. Please try again.');
    }
  };

  return (
    <div className="relative w-full p-4 bg-[#FFFFE7] shadow-lg rounded-lg">
      {/* Loading Spinner */}
      {searching && (
        <div className="absolute inset-0 bg-black bg-opacity-50 flex justify-center items-center z-10" role="status" aria-live="polite">
          <SpinnerDotted size={70} color="white" />
        </div>
      )}

      <form onSubmit={fetchAvailableRooms} className="relative">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:gap-3">
          {/* Check-In Date Picker */}
          <div className="flex-1 flex items-center border border-gray-300 rounded-lg p-3 bg-gradient-to-r from-gray-50 to-gray-100 shadow-sm">
            <CheckIn
              selectedDate={checkIn}
              onChangeDate={handleCheckInChange}
              minDate={startOfToday()}
            />
          </div>

          {/* Check-Out Date Picker */}
          <div className="flex-1 flex items-center border border-gray-300 rounded-lg p-3 bg-gradient-to-r from-gray-50 to-gray-100 shadow-sm">
            <CheckOut
              selectedDate={checkOut}
              onChangeDate={setCheckOut}
              checkInDate={checkIn}
            />
          </div>

          {/* Adults Dropdown */}
          <div className="flex-1 flex items-center border border-gray-300 rounded-lg p-3 bg-gradient-to-r from-gray-50 to-gray-100 shadow-sm">
            <AdultsDropdown />
          </div>

          {/* Kids Dropdown */}
          <div className="flex-1 flex items-center border border-gray-300 rounded-lg p-3 bg-gradient-to-r from-gray-50 to-gray-100 shadow-sm">
            <KidsDropdown />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className={`w-full lg:w-auto ${
              searching ? 'bg-gray-400 cursor-not-allowed' : 'bg-gradient-to-r from-yellow-500 to-yellow-600'
            } text-white font-bold py-3 px-6 rounded-lg shadow-md hover:shadow-lg transition-transform duration-300 transform hover:scale-105`}
            disabled={searching}
          >
            {searching ? 'Checking...' : 'Check Now'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default BookForm;   




